<template>
  <div :class="[this.errorMessageLocal !== '' || this.errorMessage !== '' ?
  $style.divComponentError : $style.divComponent]">
    <PdsInput
      :type="typeLocal"
      :id="id"
      :aria-label="ariaLabel"
      :label="label"
      :value="value"
      :errorMessage="this.errorMessageLocal.length > 0 ? this.errorMessageLocal : this.errorMessage"
      :required="required"
      :helperText="helperText"
      @blur="validateEmpty"
      v-model="text"
      :action="this.actionParent"
      :maxlength="maxlength"
      :disabled="disabled"
      :tabindex="tabindexinput" />
    <div v-if="textLink !== null"
      :class="[this.errorMessageLocal === '' ? $style.link : $style.linkWithError]">
      <div v-if="nameIcon !== ''" :class="[$style.icon]"
      @click="() => { this.$emit('actionLink', true); }">
        <PdsIcon
          :name="nameIcon"
          :fill="colorIcon"
          isPointer />
      </div>
      <div @click="() => { this.$emit('actionLink', true); }">
        <PdsLink
          :text="textLink"
          link="javascript:;" />
      </div>
    </div>
  </div>
</template>

<script>
import PdsInput from '@vue-pds/input';
import PdsLink from '@vue-pds/link';
import PdsIcon from '@vue-pds/icon';
import { removeFormatRut } from '@/utils/functions';
import _ from 'lodash';

export default {
  name: 'Input',
  components: {
    PdsInput,
    PdsLink,
    PdsIcon,
  },
  data() {
    return {
      text: '',
      typeLocal: 'text',
      errorMessageLocal: '',
      actionParent: false,
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    typeinput: {
      type: String,
      required: false,
      default: 'text',
    },
    label: {
      type: String,
      required: false,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    messageEmpty: {
      type: String,
      required: false,
      default: '',
    },
    helperText: {
      type: String,
      required: false,
    },
    ariaLabel: {
      type: String,
      default: null,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    action: {
      type: Boolean,
      default: false,
      required: false,
    },
    maxlength: {
      type: String,
      required: false,
    },
    textLink: {
      type: String,
      default: null,
      required: false,
    },
    nameIcon: {
      type: String,
      default: '',
      required: false,
    },
    colorIcon: {
      type: String,
      default: '',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    tabindexinput: {
      type: String,
      required: false,
    },
    order: {
      default: 9999,
    },
  },
  methods: {
    validateEmpty() {
      if (this.required && (this.text === '' || this.text === null)) {
        this.errorMessageLocal = this.messageEmpty === '' ? 'Debes completar este campo' : this.messageEmpty;
        this.$emit('error', { id: this.id, error: true, order: this.$props.order });
        this.$emit('data', { id: this.id, value: this.text });
      } else {
        if (this.$props.typeinput === 'rut') {
          if (!this.validateFormat(this.text)) {
            this.$emit('error', { id: this.id, error: true, order: this.$props.order });
          } else {
            this.$emit('error', { id: this.id, error: false, order: this.$props.order });
          }
        }
        if (this.$props.typeinput !== 'rut') {
          this.$emit('data', { id: this.id, value: this.text });
        } else {
          this.$emit('data', { id: this.id, value: this.limpiarRutDv(this.text) });
        }
      }
    },
    validateFormat(value) {
      if (value) {
        const noFormat = this.removeFormatRut(value);
        let dv = noFormat.charAt(noFormat.length - 1);
        dv = dv === 'K' || dv === 'k' ? 'K' : dv;

        let rut = parseInt(noFormat.substring(0, noFormat.length - 1), 10);
        let m = 0;
        let s = 1;

        for (; rut; rut = Math.floor(rut / 10)) {
          // eslint-disable-next-line no-plusplus
          s = (s + (rut % 10) * (9 - (m++ % 6))) % 11;
        }

        return dv === (s ? s - 1 : 'K').toString();
      }

      return true;
    },
    formatRut(value) {
      const noFormat = this.removeFormatRut(value);
      const rut = noFormat.length > 1 ? noFormat.slice(0, -1) : noFormat;
      const dv = noFormat.length > 1 ? noFormat.slice(noFormat.length - 1) : null;
      const result = rut.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      return dv == null ? result : `${result}-${dv}`;
    },
    setFormatSerialNumber(value) {
      const symbol = 'A';
      const startA = _.startsWith(value, symbol);
      const replace = startA ? '' : '.';
      const limit = !startA ? 11 : 10;
      let serialNumberReset = value.slice(0, limit);
      serialNumberReset = serialNumberReset.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, replace);
      if (!startA || !value) {
        return `${serialNumberReset}`;
      }
      return `${symbol}${serialNumberReset}`;
    },
    setNewSerialNumberFormat(value) {
      const serialMaxLength = 10;
      const serialNumberValue = (value.replace(/[\W_]/g, '')).slice(0, serialMaxLength);
      return (serialNumberValue.replace(/\B(?=(\w{3})+(?!\w))/g, '.')).toUpperCase();
    },
    validateSerialNumberFormat(value) {
      let errorSerial = true;
      if (value !== null) {
        if (_.startsWith(value, 'A')) {
          if (value.length < 10) {
            errorSerial = false;
          }
        }
      }
      if (value !== null) {
        if (!_.startsWith(value, 'A')) {
          if (value.length < 11) {
            errorSerial = false;
          }
        }
      }
      return errorSerial;
    },
    validateNewSerialNumberFormat(value) {
      const cleanValue = value.toString().replace(/[\W_]/g, '');
      const newSerialNumberFormatRegex = /^(?!(?:.*[a-zA-Z]){3,})[a-zA-Z0-9]{9,10}$/g;
      /**
      - `^` y `$` indican el inicio y fin de la cadena, respectivamente.
      - `(?!(?:.*[A-Z]){3,})` es una aserción negativa que busca que no
        haya más de 2 letras en la cadena.
      - `[A-Z0-9]{9,10}` permite cualquier combinación de letras
        y números con una longitud entre 9 y 10 caracteres.
      */
      const isValid = newSerialNumberFormatRegex.test(cleanValue);
      return isValid;
    },
    validateEmailFormat(value) {
      let errorEmail = false;
      if (value !== null) {
        const mailformat = /^[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;
        errorEmail = mailformat.test(value);
      }
      return errorEmail;
    },
    limpiarRutDv(rut) {
      if (rut) {
        return { rut: removeFormatRut(rut).slice(0, -1), dv: rut.substr(-1) };
      }
      return '';
    },
    removeFormatRut(value) {
      return String(value).toUpperCase().replace(/[^0-9Kk]+/g, '');
    },
    setFormatMiles(value) {
      if (value !== null && value.length > 0) {
        const valor = String(value).replace(/[^0-9]+/g, '');
        return `$${valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
      }
      return '';
    },
    soloTexto(value) {
      return value.replace(/\d/g, '');
    },
    soloNumero(value) {
      return value.replace(/\D/g, '');
    },
    clave(value) {
      return value;
    },
  },
  created() {
    this.typeLocal = ['rut', 'miles', 'soloTexto', 'soloNumero', 'tel', 'email', 'numeroSerie'].indexOf(this.$props.typeinput) !== -1
      ? 'text' : this.$props.typeinput;

    this.text = (this.value !== '' && this.value !== undefined) ? this.value : this.text;
  },
  watch: {
    text(value) {
      this.$emit('error', { id: this.id, error: false, order: this.$props.order });
      if (value !== '' && value !== null) {
        this.errorMessageLocal = '';
        if (this.$props.typeinput === 'rut') {
          this.text = this.formatRut(value);
          if (!this.validateFormat(value)) {
            this.errorMessageLocal = 'Formato inválido';
            this.$emit('error', { id: this.id, error: true, order: this.$props.order });
          }
        }
        if (this.$props.typeinput === 'miles') {
          this.text = this.setFormatMiles(value);
        }
        if (this.$props.typeinput === 'soloTexto') {
          this.text = this.soloTexto(value);
        }
        if (this.$props.typeinput === 'soloNumero') {
          this.text = this.soloNumero(value);
        }
        if (this.$props.typeinput === 'password') {
          this.text = this.clave(value);
          this.$emit('data', { id: this.id, value: this.text });
        }
        if (this.$props.typeinput === 'numeroSerie') {
          this.text = this.setNewSerialNumberFormat(value);
          if (!this.validateNewSerialNumberFormat(value)) {
            this.errorMessageLocal = 'Formato inválido';
            this.$emit('error', { id: this.id, error: true, order: this.$props.order });
          }
        }
        if (this.$props.typeinput === 'email') {
          this.text = value;
          if (!this.validateEmailFormat(value)) {
            this.errorMessageLocal = 'Formato inválido';
            this.$emit('error', { id: this.id, error: true, order: this.$props.order });
          }
        }
        if (this.$props.typeinput === 'tel') {
          this.text = this.soloNumero(value);
          if (value.length !== 8) {
            this.errorMessageLocal = 'Ingrese 8 dígitos';
            this.$emit('error', { id: this.id, error: true, order: this.$props.order });
          }
          if (value.length === 8) {
            this.$emit('data', { id: this.id, value: this.text });
          }
        }
      }
    },
    action(value) {
      if (value) {
        this.validateEmpty();
      }
    },
    value(value) {
      this.text = (value !== '' && value !== undefined) ? value : this.text;
    },
  },
};
</script>

<style lang="scss" scoped module>

.divComponent {
  position: relative;
  margin-bottom: 20px;
}

.divComponentError {
  position: relative;
}

.divComponentError > :first-child {
  height: 120px;
}

.link {
  display: flex;
  margin-top: 10px;
}

.linkWithError {
  position: relative;
  bottom: 15px;
  display: flex;
}

.icon {
  padding-right: 7px;
}

.label {
  letter-spacing: 0;
}

@media (max-width: 360px) {
  .divComponentError > :first-child {
    .pdserror {
      font-size: 15px !important;
    }
  }
}

</style>
